import * as React from 'react';
import {Component} from "react";
import nophoto from "../../assets/img/nophoto.png"
import connect from "react-redux/es/connect/connect";
import HomePageAgentListLoaderCard from "../../../src/components/profile/home-page-agent-list-loader-card"
import {Link} from "react-router-dom";
import {Fragment} from "react";
import {getConnection} from "../../actions/profile";
import CommanAgentCard from "./commanAgentCard";
import DataNotFound from "../layout/DataNotFound";
import {AGENTS} from "../../actions/types";
import Navbar from "../common/navbar/Navbar";
import HeroSection from "../common/HerroSection/hero-section";

class ConnectionListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_lastData:true,
            q: '',
            offset: 0,
            limit: 15,
            errors: {},
        }
    }

    onChange = (e) => this.setState({[e.target.name]: e.target.value}, () => {
        /*if (this.state.q.length < 1) {
            this.setState({offset: 0});
            // this.props.getConnection(this.state.q, `offset=${this.state.offset}`);
        }*/

    });

    handleSearchValidation = () => {
        let fields = this.state;
        let errors = {};
        let formIsValid = true;
        if (!fields.q) {
            // formIsValid = false;
            // errors.q = "Please type something to search related data!";
        }

        this.setState({errors: errors});
        return formIsValid;
    };

    handleSearchSubmit = (e) => {
        console.log('handleSearchSubmit called');
        e.preventDefault();
        if (this.handleSearchValidation()) {
            this.setState({offset: 0});
            const request = {
                q :this.state.q,
                offset :this.state.offset,
                limit:this.state.limit
            };
            this.props.getConnection(this.props.user._id);

        }

    };

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = "Connections | Prime Private Network";
        const request = {
            q :'',
            offset :0,
            limit:this.state.limit
        };
        if (this.props.user._id){
            this.props.getConnection(this.props.user._id);
        }


     /*   window.addEventListener('scroll', () => {
            let scrollHeight = document.documentElement.scrollHeight;
            let scrollTop = document.documentElement.scrollTop;
            let clientHeight = document.documentElement.clientHeight;

            if ((scrollTop + clientHeight) > (scrollHeight - 300) && this.props.agents.length && !this.props.connectionLoader && this.state.is_lastData) {
                this.setState({offset: this.state.offset + 1}, () =>  this.props.getConnection({q:this.state.q,offset:this.state.offset,limit:this.state.limit},this.setLastData));
            }
        });
        this.setState({offset: 0});*/
    }

    setLastData=(status)=>{
        console.log(status,"status");
        this.setState({is_lastData:status})
    };
    render() {
        const {connectionLoader,connection} = this.props;
        const loggedinId = this.props.user && this.props.user._id;
        //console.log(this.props.connection &&this.props.connection.sentRequests.map(friend => friend),'iddddddd');
        return (
            <Fragment>
                <Navbar/>
                <HeroSection title={'Connection'}/>
                <div className="container mt-5">
                    <div className="input-group mb-3 w-75 mx-auto">
                        <input type="text" className="form-control" placeholder="Search By  Connection Name or Connection Email"
                               aria-label="Recipient's username" aria-describedby="basic-addon2"
                               id="q" name={'q'}
                               value={this.state.q} onChange={this.onChange}/>
                            <div className="input-group-append">
                                <button className="btn btn-secondary" type="submit" onClick={this.handleSearchSubmit}>
                                    <i className="fa fa-search"/></button>
                            </div>
                    </div>
                        {
                            (this.props.connection && this.props.connection.length > 0) && this.props.connection.map((connection,i) =>
                                <CommanAgentCard
                                    key={i}
                                    loggedinId={loggedinId}
                                    is_online={connection.is_online}
                                    is_typing={connection.is_typing}
                                    userId={connection._id}
                                    avatar={connection.avatar}
                                    name={connection.name}
                                    phone={connection.phone}
                                    email={connection.email}
                                    friends={connection.friends}
                                    country={connection.country.name ? connection.country.name : ''}
                                    state={connection.state.name ? connection.state.name : ''}
                                    city={connection.city.name ? connection.city.name : ''}
                                    properties={connection.properties}
                                    experience={connection.number_of_years_in_business}
                                    sentRequests={connection.sentRequests}
                                    receivedRequests={connection.receivedRequests}
                                    blockedFriends={connection.blockedFriends}
                                />)
                            }
                    {(!connectionLoader && connection.length < 1) &&
                    <div className="text-center col-md-12"><DataNotFound
                        message={`Sorry! No any Connection found.`}/></div>}


                        {(this.props.connectionLoader) && <Fragment>
                            <HomePageAgentListLoaderCard/>
                            <HomePageAgentListLoaderCard/>
                            <HomePageAgentListLoaderCard/>
                            <HomePageAgentListLoaderCard/>
                        </Fragment>}
                    </div>
            </Fragment>
        );
    }
}

const mapStatToProps = state => {
    return {
        connectionLoader: state.profile.connectionLoader,
        connection: state.profile.connection,
        user: state.auth.user
    }
};

export default connect(mapStatToProps, {getConnection})(ConnectionListing);
